import { Link } from 'react-router-dom'


import MarqueeSlider from './MarqueeSlider'

const items = [
  {
    link: 'https://www.upper.energy/',
    image: './images/upper.jpg'
  },{
    link: 'https://www.caliente.mx/',
    image: './images/caliente.jpg'
  },{
    link: 'https://www.riu.com/es/hotel/mexico/guadalajara/hotel-riu-plaza-guadalajara/',
    image: './images/riu.jpg'
  },{
    link: 'https://www.cervezacorona.mx/',
    image: './images/corona.png'
  },{
    link: 'https://www.ticketnowmexico.com/',
    image: './images/ticketnow.png'
  },{
    link: 'https://www.cocacola.com/mx/es',
    image: './images/coca-cola.jpg'
  },
  {
    link: 'https://cerveceriachapultepec.com/',
    image: './images/chapulogo.jpg'
  },
  {
    link: 'https://www.ocesa.com.mx/',
    image: './images/ocesa.png'
  },
  {
    link: 'https://www.toyota.mx/',
    image: './images/toyota.jpeg'
  },
  {
    link: 'https://cuervotradicional.com.mx/',
    image: './images/tradicional.jpg'
  },
  {
    link: 'https://estadioakron.mx/',
    image: './images/akron.jpg'
  },{
    link: 'https://www.auditorio-telmex.com/',
    image: './images/telmex.jpg'
  },
  {
    link: 'https://baramericas.com.mx/calendar/',
    image: './images/americasbar.png'
  },
  {
    link: 'https://www.arenavfg.mx/eventos/',
    image: './images/arenavfg.jpg'
  },
  
  // Add more items as needed
]; 

      
function ButtonTreeCategories() {
  return (
    <>
    
   <div className="sponsorcontainer1">

   <Link className="btn" to="/artificial">
        <img
          src="../images/aibot.jpeg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
    
      <Link className="btn" to="/hits">
        <img
          src="../images/hits.jpeg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>

      <Link className="btn" to="/mariachi">
        <img
          src="../images/regimex.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>

      <Link className="btn" to="/banda">
        <img
          src="../images/bandalogo.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/sierreño">
        <img
          src="../images/sierreña.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/norteño">
        <img
          src="../images/norteño.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn " to="/reggaeton">
        <img
          src="../images/reggaetonlogo.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/reggae">
    <img
      src="../images/reggaelogo.jpg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>

  

  <Link className="btn" to="/pop">
    <img
      src="../images/pop.jpeg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
  <Link className="btn" to="/solistas">
        <img
          src="../images/solistas.jpg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
  <Link className="btn" to="/clubmusic">
    <img
      src="../images/clubmusiclogo.jpeg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
  <Link className="btn" to="/chill">
    <img
      src="../images/chill.jpg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
   
      <Link className="btn" to="/rockesp">
        <img
          src="../images/rockesp.jpeg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/alternative">
      <img
        src="../images/alternativelogo.png"
        className="sponsor1"
        alt=""
        media="(max-inline-size: 400px)"
      />
    </Link>
    <Link className="btn" to="/classicrock">
    <img
      src="../images/classicrock.jpeg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
  <Link className="btn" to="/softrock">
  <img
    src="../images/softrock.jpeg"
    className="sponsor1"
    alt=""
    media="(max-inline-size: 400px)"
  />
</Link>
  <Link className="btn" to="/metal">
  <img
    src="../images/metal.png"
    className="sponsor1"
    alt=""
    media="(max-inline-size: 400px)"
  />
</Link>
<Link className="btn" to="/punk">
<img
  src="../images/punk.jpeg"
  className="sponsor1"
  alt=""
  media="(max-inline-size: 400px)"
/>
</Link>

      <Link className="btn " to="/raptrap">
        <img
          src="../images/rap3.jpg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/hiphop">
        <img
          src="../images/nigga.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>

      <Link className="btn" to="/Rhythm&Blues">
        <img
          src="../images/rythm.jpg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      
      <Link className="btn" to="/salsa">
      <img
        src="../images/salsa.jpg"
        className="sponsor1"
        alt=""
        media="(max-inline-size: 400px)"
      />
    </Link>
    <Link className="btn" to="/bachatta">
      <img
        src="../images/bachatta.jpg"
        className="sponsor1"
        alt=""
        media="(max-inline-size: 400px)"
      />
    </Link>
    <Link className="btn" to="/romantica">
    <img
      src="../images/romanticas.jpeg"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
  <Link className="btn" to="/cumbias">
    <img
      src="../images/cumbialogo.png"
      className="sponsor1"
      alt=""
      media="(max-inline-size: 400px)"
    />
  </Link>
  <Link className="btn" to="/sonidero">
  <img
    src="../images/sonidero.png"
    className="sponsor1"
    alt=""
    media="(max-inline-size: 400px)"
  />
</Link>
<Link className="btn" to="/rancheras">
<img
  src="../images/ranchera.jpeg"
  className="sponsor1"
  alt=""
  media="(max-inline-size: 400px)"
/>
</Link>  
      
      
      <Link className="btn" to="/blues">
        <img
          src="../images/blues.jpg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/jazz">
        <img
          src="../images/jazz.jpg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/EpocadeOro">
        <img
          src="../images/Classica!.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/oldies">
        <img
          src="../images/oldies.jpeg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      
      
      <Link className="btn" to="/baroque">
        <img
          src="../images/classica.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      
      
     {/*} <Link className="btn" to="/femeninas">
        <img
          src="../images/cantantes.png"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>*/}
      
     
      
      
      <Link className="btn" to="/country">
        <img
          src="../images/country.jpeg"
          className="sponsor1"
          alt=""
          media="(max-inline-size: 400px)"
        />
      </Link>
      <Link className="btn" to="/funk">
      <img
        src="../images/funk.jpg"
        className="sponsor1"
        alt=""
        media="(max-inline-size: 400px)"
      />
    </Link>
    <Link className="btn" to="/trova">
      <img
        src="../images/trova.png"
        className="sponsor1"
        alt=""
        media="(max-inline-size: 400px)"
      />
    </Link>
   
   {/* <Link 
    className="btn" 
    to="/events" 
    style={{
      textAlign: 'center', 
    }}
  >
    <button>
      Para Buscar Eventos en Guadalajara Presiona Aqui !!!
    </button>
  </Link>

  
  

  
     <div>
  <h1 style={{fontFamily:'Iceland', backgroundColor:"black", color:'goldenrod', fontSize:'15px', marginLeft:'25px', textAlign:'center' }}> Patrocinadores:</h1>

    <MarqueeSlider items={items} />
      </div>*/}
      </div>
     </>
  )
}

export default ButtonTreeCategories